import React, { FC } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

interface IProps {
  size?: 'md';
  className?: string;
}

const Loader: FC<IProps> = ({ size, className }) => (
  <div className={classNames(css.loader, { [css[`loader_size_${size}`]]: size }, className)}>
    <Icon id={size === 'md' ? '32--loader' : '16--small-loader'} />
  </div>
);

export default Loader;
